import { Component, Vue } from 'vue-property-decorator';
import { IListItem } from "@/models/core/core";

@Component
export default class I18nToSelectItems extends Vue {

	protected setSelectItems(key: string, i18nKey: string) {
		const items: Array<IListItem> = [];

		for (let [ key, val ] of Object.entries(this.$t(i18nKey))) {
			items.push({ key, val });
		}

		(this as any)[key] = items;
	}

}